module.exports = __webpack_public_path__ + "h5/img/xinzhuan.16834829.png";